export default "__VITE_ASSET__BtrLMpvl__"